// src/actions/delhiActions.js
import axios from 'axios';
import {
    GET_DELHI_RECORDS_REQUEST,
    GET_DELHI_RECORDS_SUCCESS,
    GET_DELHI_RECORDS_FAIL,
    GET_DELHI_RECORDS_RESET,
    CREATE_DELHI_RECORD_REQUEST,
    CREATE_DELHI_RECORD_SUCCESS,
    CREATE_DELHI_RECORD_FAIL,
    CREATE_DELHI_RECORD_RESET,
    UPDATE_DELHI_RECORD_REQUEST,
    UPDATE_DELHI_RECORD_SUCCESS,
    UPDATE_DELHI_RECORD_FAIL,
    UPDATE_DELHI_RECORD_RESET,
    DELETE_DELHI_RECORD_REQUEST,
    DELETE_DELHI_RECORD_SUCCESS,
    DELETE_DELHI_RECORD_FAIL,
    DELETE_DELHI_RECORD_RESET,
    BULK_DELETE_DELHI_RECORDS_REQUEST,
    BULK_DELETE_DELHI_RECORDS_SUCCESS,
    BULK_DELETE_DELHI_RECORDS_FAIL,
    BULK_DELETE_DELHI_RECORDS_RESET,
    IMPORT_DELHI_RECORDS_REQUEST,
    IMPORT_DELHI_RECORDS_SUCCESS,
    IMPORT_DELHI_RECORDS_FAIL,
    IMPORT_DELHI_RECORDS_RESET,
    EXPORT_DELHI_RECORDS_REQUEST,
    EXPORT_DELHI_RECORDS_SUCCESS,
    EXPORT_DELHI_RECORDS_FAIL,
    EXPORT_DELHI_RECORDS_RESET,
    UPDATE_DELHI_CELL_REQUEST,
    UPDATE_DELHI_CELL_SUCCESS,
    UPDATE_DELHI_CELL_FAIL,
    UPDATE_DELHI_CELL_RESET,
} from '../constants/delhiConstants';
import { logout } from './userActions';

const baseUrl = process.env.REACT_APP_API_URL;

// Get Delhi records with pagination and search
// Update getDelhiRecords function in delhiActions.js:

export const getDelhiRecords = (queryParams = '') => async (dispatch, getState) => {
    try {
        dispatch({
            type: GET_DELHI_RECORDS_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        // Parse and validate query parameters
        const params = new URLSearchParams(queryParams);
        const page = Math.max(1, parseInt(params.get('page')) || 1);
        const limit = Math.max(1, parseInt(params.get('limit')) || 10);
        const search = params.get('search') || '';
        const importDate = params.get('importDate') || '';
        const status = params.get('status') || ''; // ADD THIS LINE
        const typeFilter = params.get('typeFilter') || '';
        const departmentFilter = params.get('departmentFilter') || '';
        const fosFilter = params.get('fosFilter') || '';

        // Rebuild clean query string
        let cleanQuery = `search=${encodeURIComponent(search)}&page=${page}&limit=${limit}`;
        if (importDate) {
            cleanQuery += `&importDate=${encodeURIComponent(importDate)}`;
        }
        if (status) { // ADD THIS BLOCK
            cleanQuery += `&status=${encodeURIComponent(status)}`;
        }
        if (typeFilter) {
            cleanQuery += `&typeFilter=${encodeURIComponent(typeFilter)}`;
        }
        if (departmentFilter) {
            cleanQuery += `&departmentFilter=${encodeURIComponent(departmentFilter)}`;
        }
        if (fosFilter) {
            cleanQuery += `&fosFilter=${encodeURIComponent(fosFilter)}`;
        }

        console.log('API Call with params:', { search, page, limit, importDate, status, typeFilter, departmentFilter, fosFilter }); // Update debug log

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo?.token}`,
            },
        };

        const { data } = await axios.get(
            `${baseUrl}/delhi?${cleanQuery}`,
            config
        );

        dispatch({
            type: GET_DELHI_RECORDS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        console.error('getDelhiRecords error:', error);
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: GET_DELHI_RECORDS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};


// Create new Delhi record
export const createDelhiRecord = (recordData) => async (dispatch, getState) => {
    try {
        dispatch({
            type: CREATE_DELHI_RECORD_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo?.token}`,
            },
        };

        const { data } = await axios.post(
            `${baseUrl}/delhi`,
            recordData,
            config
        );

        dispatch({
            type: CREATE_DELHI_RECORD_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: CREATE_DELHI_RECORD_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

// Update Delhi record
export const updateDelhiRecord = (id, recordData) => async (dispatch, getState) => {
    try {
        dispatch({
            type: UPDATE_DELHI_RECORD_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo?.token}`,
            },
        };

        const { data } = await axios.put(
            `${baseUrl}/delhi/${id}`,
            recordData,
            config
        );

        dispatch({
            type: UPDATE_DELHI_RECORD_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: UPDATE_DELHI_RECORD_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

// Update single cell (for inline editing)
export const updateDelhiCell = (id, field, value) => async (dispatch, getState) => {
    try {
        dispatch({
            type: UPDATE_DELHI_CELL_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo?.token}`,
            },
        };

        const { data } = await axios.put(
            `${baseUrl}/delhi/${id}`,
            { [field]: value },
            config
        );

        dispatch({
            type: UPDATE_DELHI_CELL_SUCCESS,
            payload: { id, field, value: data[field] },
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: UPDATE_DELHI_CELL_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

// Delete single Delhi record
export const deleteDelhiRecord = (id) => async (dispatch, getState) => {
    try {
        dispatch({
            type: DELETE_DELHI_RECORD_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo?.token}`,
            },
        };

        await axios.delete(`${baseUrl}/delhi/${id}`, config);

        dispatch({
            type: DELETE_DELHI_RECORD_SUCCESS,
            payload: id,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: DELETE_DELHI_RECORD_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

// Bulk delete Delhi records
export const bulkDeleteDelhiRecords = (ids) => async (dispatch, getState) => {
    try {
        dispatch({
            type: BULK_DELETE_DELHI_RECORDS_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo?.token}`,
            },
        };

        const { data } = await axios.post(
            `${baseUrl}/delhi/bulk-delete`,
            { ids },
            config
        );

        dispatch({
            type: BULK_DELETE_DELHI_RECORDS_SUCCESS,
            payload: { ids, deletedCount: data.deletedCount },
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: BULK_DELETE_DELHI_RECORDS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

// Import Delhi records from file
export const importDelhiRecords = (formData) => async (dispatch, getState) => {
    try {
        dispatch({
            type: IMPORT_DELHI_RECORDS_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${userInfo?.token}`,
            },
        };

        const { data } = await axios.post(
            `${baseUrl}/delhi/import`,
            formData,
            config
        );

        dispatch({
            type: IMPORT_DELHI_RECORDS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: IMPORT_DELHI_RECORDS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

// Export Delhi records
export const exportDelhiRecords = () => async (dispatch, getState) => {
    try {
        dispatch({
            type: EXPORT_DELHI_RECORDS_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo?.token}`,
            },
            responseType: 'blob',
        };

        const { data } = await axios.get(
            `${baseUrl}/delhi/export`,
            config
        );

        // Create download link
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Delhi_Export.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        dispatch({
            type: EXPORT_DELHI_RECORDS_SUCCESS,
            payload: 'Export completed successfully',
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: EXPORT_DELHI_RECORDS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

// Reset Actions
export const resetDelhiRecords = () => ({
    type: GET_DELHI_RECORDS_RESET,
});

export const resetCreateDelhiRecord = () => ({
    type: CREATE_DELHI_RECORD_RESET,
});

export const resetUpdateDelhiRecord = () => ({
    type: UPDATE_DELHI_RECORD_RESET,
});

export const resetDeleteDelhiRecord = () => ({
    type: DELETE_DELHI_RECORD_RESET,
});

export const resetBulkDeleteDelhiRecords = () => ({
    type: BULK_DELETE_DELHI_RECORDS_RESET,
});

export const resetImportDelhiRecords = () => ({
    type: IMPORT_DELHI_RECORDS_RESET,
});

export const resetExportDelhiRecords = () => ({
    type: EXPORT_DELHI_RECORDS_RESET,
});

export const resetUpdateDelhiCell = () => ({
    type: UPDATE_DELHI_CELL_RESET,
});

// Sync task status from Task to Delhi
// Update the existing syncTaskStatus action
export const syncTaskStatus = () => async (dispatch, getState) => {
    try {
        dispatch({
            type: 'SYNC_TASK_STATUS_REQUEST',
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo?.token}`,
            },
        };

        const { data } = await axios.post(
            `${baseUrl}/delhi/sync-status`,
            {},
            config
        );

        dispatch({
            type: 'SYNC_TASK_STATUS_SUCCESS',
            payload: data,
        });

        return data; // Return data including updatedRecords
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: 'SYNC_TASK_STATUS_FAIL',
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
        throw error;
    }
};

export const getFieldExecutives = (search = '') => async (dispatch, getState) => {
    try {
        dispatch({
            type: 'GET_FIELD_EXECUTIVES_REQUEST',
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo?.token}`,
            },
        };

        const { data } = await axios.get(
            `${baseUrl}/delhi/field-executives?search=${encodeURIComponent(search)}`,
            config
        );

        dispatch({
            type: 'GET_FIELD_EXECUTIVES_SUCCESS',
            payload: data,
        });

        return data; // ADD THIS LINE - Return the data
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: 'GET_FIELD_EXECUTIVES_FAIL',
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
        throw error; // ADD THIS LINE - Throw error so it can be caught
    }
};

export const getDepartments = () => async (dispatch, getState) => {
    try {
        dispatch({
            type: 'GET_DEPARTMENTS_REQUEST',
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo?.token}`,
            },
        };

        const { data } = await axios.get(
            `${baseUrl}/delhi/departments`,
            config
        );

        dispatch({
            type: 'GET_DEPARTMENTS_SUCCESS',
            payload: data,
        });

        return data;
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: 'GET_DEPARTMENTS_FAIL',
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
        throw error;
    }
};

export const getFOS = (importDate = '') => async (dispatch, getState) => {
    try {
        dispatch({
            type: 'GET_FOS_REQUEST',
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo?.token}`,
            },
        };

        // Build URL with importDate query parameter if provided
        let url = `${baseUrl}/delhi/fos`;
        if (importDate) {
            url += `?importDate=${encodeURIComponent(importDate)}`;
        }

        const { data } = await axios.get(url, config);

        dispatch({
            type: 'GET_FOS_SUCCESS',
            payload: data,
        });

        return data;
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: 'GET_FOS_FAIL',
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
        throw error;
    }
};

